import FormWidget from "../form-widget.js";

class RangeWidget extends FormWidget {
    public override process() {
        const fieldEl = this.element as HTMLInputElement;

        const unit = fieldEl.getAttribute('unit') ? ' '+fieldEl.getAttribute('unit') : '';

        if(!fieldEl.parentElement?.classList.contains('input-group')) {
            const wrappEl = document.createElement('div');
            wrappEl.setAttribute('class', 'input-group');
            fieldEl.after(wrappEl);
            wrappEl.append(fieldEl);
        }
        fieldEl.classList.remove('form-control');

        const formControlEl = document.createElement('div');
        formControlEl.setAttribute('class', 'form-control d-flex flex-column');
        fieldEl.after(formControlEl);
        formControlEl.append(fieldEl);

        const rangeValueEl = document.createElement('div');
        rangeValueEl.setAttribute('class', 'range-value input-group-text justify-content-center');
        rangeValueEl.style.minWidth = '60px';
        rangeValueEl.innerHTML = fieldEl.value;



        formControlEl.parentElement?.append(rangeValueEl);

        const updateView = function() {
            rangeValueEl.innerHTML = fieldEl.value + unit;
        }

        fieldEl.addEventListener('input', updateView);
        fieldEl.addEventListener('change', updateView);
        updateView();
    }

}

export default RangeWidget;
